import * as React from 'react';
import { connect } from 'react-redux';
import { IState } from '../CustomTypes';
import {
  BackgroundColor,
  Card,
  classNames,
  Heading,
  Margin,
} from '@snoam/pinata';

export interface IStateProps {
  showWarning?: boolean;
}

const styleClass = {
  heading: classNames(Margin.MB_3),
  wrapper: classNames(BackgroundColor.BG_WARNING),
};

class TimeoutMessage extends React.Component<
  IStateProps,
  Record<string, never>
> {
  public static displayName = 'TimeoutMessage';

  public render() {
    if (!this.props.showWarning) {
      return null;
    }

    return (
      <Card className={styleClass.wrapper}>
        <Heading className={styleClass.heading}>Timeout</Heading>

        <p>Det er gått for lang tid uten at det ble gjort noe.</p>
        <p>Du er derfor logget ut og må starte på nytt.</p>
      </Card>
    );
  }
}

export default connect<
  IStateProps,
  Record<string, never>,
  Record<string, never>
>((state: IState) => ({
  showWarning: state.timeout.showWarning,
}))(TimeoutMessage);
